module.exports = __webpack_public_path__ + "static/configuration-65c5a4ad3551924682624aaacf2a9f3f.jpg";